<template>
  <div class="issued-log">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item label="下发类型">
          <el-select v-model="form.issueType" @change="getList">
            <el-option label="全部" value=""></el-option>
            <el-option label="设备升级" :value="2"></el-option>
            <el-option label="参数配置" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="当前状态">
          <el-select v-model="form.resultCode" @change="getList">
            <el-option label="全部" value=""></el-option>
            <el-option label="待下发" :value="0"></el-option>
            <el-option label="成功" :value="1"></el-option>
            <el-option label="失败" :value="2"></el-option>
            <el-option label="下发中" :value="3"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="table" height="700">
      <el-table-column label="设备编码" prop="deviceCode"></el-table-column>
      <el-table-column label="下发类型">
        <template #default="scope">
          {{({
            1: '参数配置',
            2: '设备升级'
          }[scope.row.issueType])}}
        </template>
      </el-table-column>
      <el-table-column label="下发内容">
        <template #default="scope">
          <!-- {{scope.row.issueType == 2 ? scope.row.config.version : ''}} -->
          {{scope.row.configData}}
        </template>
      </el-table-column>
      <el-table-column label="当前状态">
        <template #default="scope">
          {{({
            0: '待下发',
            1: '成功',
            2: '失败',
            3: '下发中',
          }[scope.row.resultCode])}}
        </template>
      </el-table-column>
      <el-table-column label="下发时间">
        <template #default="scope">
          {{formatTime(scope.row.createTime)}}
        </template>
      </el-table-column>
      <el-table-column label="状态更新时间">
        <template #default="scope">
          {{formatTime(scope.row.updateTime)}}
        </template>
      </el-table-column>
      <el-table-column label="结果" prop="resultRemark"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import {formatTime} from "@/utils/index.js";
export default{
  name: "IssuedLog",
  data(){
    return {
      form: {
        issueType: "",
        resultCode: ""
      },
      table: [],
    }
  },
  methods: {
    formatTime(value){
      return formatTime(value);
    },
    getList(){
      this.axios.get(`/api/web/issuedLog/findPage?issueType=${this.form.issueType}&resultCode=${this.form.resultCode}`).then(res => {
        this.table = res.data.data ? res.data.data.data.map(e => ({
          ...e,
          config: JSON.parse(e.configData),
        })) : [];
      })
    }
  },
  created(){
    this.getList();
  }
}
</script>

<style lang="less">
.issued-log{

}
</style>